import React from 'react'
import EnumInstallation, {DEFAULT_INSTALLATION} from "../utils/EnumInstallation";

const ClinicLogo = () => {
    let logoFileName = null;
    switch (DEFAULT_INSTALLATION) {
        case EnumInstallation.DXB:
            logoFileName = 'disc-dubai.png';
            break;
        case EnumInstallation.ADH:
            logoFileName = 'disc-abudhabi.png';
            break;
        case EnumInstallation.KWT:
            logoFileName = 'disc-kuwait.png';
            break;
        default:
            console.log("Error: No logo file found for installation: " + DEFAULT_INSTALLATION.code);
            logoFileName = 'disc.png';
    }

    return (
        <div className="Logo">
            <img width={175} height={55} src={process.env.PUBLIC_URL + '/assets/' + logoFileName} alt=""/>
        </div>
    )
};

export default ClinicLogo;
